export default {"src":"/_next/static/media/facebook_black.73dc2035.svg","height":49,"width":49};